/* eslint-disable tailwindcss/no-arbitrary-value -- the card frames are raw Figma values */
import classNames from 'classnames';
import { TextClasses } from './types';
import { EnumFlexibleHeroBlockTheme } from '$/(cms)/_modules/cmsService/types';

export const backgroundImageLight =
  'https://mhgprod.blob.core.windows.net/fe-services/content/assets/flexible-hero-block/bg-light.jpg';
export const backgroundImageDark =
  'https://mhgprod.blob.core.windows.net/fe-services/content/assets/flexible-hero-block/bg-dark.jpg';

export const LIGHT_THEME_TEXT_CLASSES: TextClasses = {
  overline: 'text-colors/campaign-blue-4',
  campaignOverline: 'text-colors/campaign-blue-4',
  headline: 'text-text/primary',
  body: 'text-text/primary',
  secondary: 'text-text/secondary-lighter',
  promoCode: 'text-fill/primary',
  // The icon's own grey fill wins over the text colour here.
  promoCopyIcon: 'text-fill/primary',
};

// Overline and secondary text are text/on-dark too: on a dark image the
// hierarchy comes from the type styles, not colour (CMS-2081). The campaign
// hero is outside that ticket and keeps its own green overline.
export const DARK_THEME_TEXT_CLASSES: TextClasses = {
  overline: 'text-text/on-dark',
  campaignOverline: 'text-colors/campaign-green-1',
  headline: 'text-text/on-dark',
  body: 'text-text/on-dark',
  secondary: 'text-text/on-dark',
  promoCode: 'text-text/on-dark',
  // ContentCopy paints its path with a fixed grey; repaint it in the text colour.
  promoCopyIcon: 'text-text/on-dark [&_path]:fill-current',
};

// Raw Figma values: neither card frame has variables bound.
export const LIGHT_THEME_PRODUCT_CARD_CLASSES = classNames(
  'backdrop-blur-frost border-[rgba(179,199,195,0.1)] bg-[rgba(179,199,195,0.16)] md:shadow-[0px_2px_7px_0px_rgba(0,0,0,0.25)]',
);

export const DARK_THEME_PRODUCT_CARD_CLASSES = classNames(
  'backdrop-blur-frost-dark border-white/40 shadow-[0px_8px_24px_0px_rgba(0,0,0,0.35)] bg-white/[.14]',
);

export const getContainerBackground = (
  theme: EnumFlexibleHeroBlockTheme | undefined,
) => {
  return theme === EnumFlexibleHeroBlockTheme.Dark
    ? backgroundImageDark
    : backgroundImageLight;
};
